import axios from "./axios";

export const getPools = async () => {
  try {
    const data = await axios.get("/api/v1/provision/pool");
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const createPool = async (data) => {
  try {
    const response = await axios.put("/api/v1/provision/pool", data);
    return response;
  } catch (error) {
    return { status: "error", error };
  }
};

export const startPool = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=start`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const stopPool = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=stop`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deletePool = async (id) => {
  try {
    const data = await axios.delete(`/api/v1/provision/pool/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getPoolCapacity = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/pool/${id}?op=get.capacity`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updatePoolCapacity = async (id, { name, capacity }) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=update.capacity`, { name, capacity });
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getPoolMySql = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/pool/${id}?op=get.mysql`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updatePoolMySql = async (id, { mysql }) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=update.mysql`, { profile: { mysql } });
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getPoolHadoop = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/pool/${id}?op=get.hadoop`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
}

export const updatePoolHadoop = async (id, { hadoop }) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=update.hadoop`, { profile: { hadoop } });
    return data;
  } catch (error) {
    return { status: "error", error };
  }
}

export const getPool = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/pool/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
}

export const retryCreatePool = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/pool/${id}?op=retry`);
    return data;
  } catch (error) {
    return { status: "error", error: error?.message };
  }
};


